const typeTester = (name: string): ((obj: unknown) => boolean) => {
  return (obj): boolean => {
    return Object.prototype.toString.call(obj) === `[object ${name}]`
  }
}

export const isArguments = typeTester('Arguments')
export const isFunction = typeTester('Function')
export const isString = typeTester('String')
export const isNumber = typeTester('Number')
export const isDate = typeTester('Date')
export const isRegExp = typeTester('RegExp')
export const isError = typeTester('Error')
export const isSymbol = typeTester('Symbol')
export const isMap = typeTester('Map')
export const isWeakMap = typeTester('WeakMap')
export const isSet = typeTester('Set')
export const isWeakSet = typeTester('WeakSet')
export const isObject = typeTester('Object')
export const isPromise = typeTester('Promise')
export const isUndefined = typeTester('Undefined')
export const isNull = typeTester('Null')
export const isArray = typeTester('Array')
export const isBlob = typeTester('Blob')
